import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SeasonPointsPipe } from './season-points.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    SeasonPointsPipe
  ],
  declarations: [
    SeasonPointsPipe
  ],
  providers: [
    SeasonPointsPipe
  ]
})
export class SeasonsModule { }
